import { DollarOutlined } from '@ant-design/icons';
import { Segmented } from 'antd';
import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import OrderMethodItem from 'components/pages/dashboard/ParcelOrder/components/orderMethods/OrderMethodItem';
import PaymentTypeReceiverNoCOD from 'components/pages/dashboard/ParcelOrder/components/orderMethods/components/PaymentTypeReceiverNoCOD';
import { priceTypeBranch } from 'components/pages/dashboard/parcelOrderForBranch/components copy/BranchOrder/BranchParcelOrderPrice';
import { FC, useEffect, useMemo } from 'react';
import { RiUserReceivedLine, RiUserSharedLine } from 'react-icons/ri';
import PaymentTypeSenderNoCOD from './PaymentTypeSenderNoCOD';

interface IOrderMethodPaymentType {
  handleChange: (_values: Partial<orderMethodsState>) => void;
  orderMethods: orderMethodsState;
  priceList?: priceTypeBranch;
  setCashAmount: (_val: number) => void;
  cashAmount: number | undefined;
}

const OrderMethodPaymentType: FC<IOrderMethodPaymentType> = ({ orderMethods, handleChange }) => {
  //states

  const paymentSide = useMemo(() => {
    if (!orderMethods.paymentSide) return 'sender';
    return orderMethods.paymentSide;
  }, [orderMethods]);
  const availableMethodIds = useMemo(() => {
    if (paymentSide === 'receiver') return [20];
    if (paymentSide === 'sender') return [80];
    // if (paymentSide === 'cashAndPayInPlace') return [100];

    return [];
  }, [paymentSide]);

  //effects
  useEffect(() => {
    if (availableMethodIds.includes(80) && orderMethods.paymentTypeId != 80) handleChange({ paymentTypeId: 80 });
    if (availableMethodIds.includes(20) && orderMethods.paymentTypeId != 20) handleChange({ paymentTypeId: 20 });
    // if (availableMethodIds.includes(100)) handleChange({ paymentTypeId: 100 });
  }, [availableMethodIds]);

  //functions
  const handleSideChange = (value: any) => {
    if (value === 'senderReceiver') handleChange({ paymentSide: 'senderReceiver', paymentTypeId: 70, haveCOD: false });
    handleChange({ paymentSide: value });
  };

  console.log('avvvvv', availableMethodIds);

  const segmentedOptions = useMemo(() => {
    const options = [
      {
        label: (
          <div className='flex items-center gap-1 pt-1'>
            <RiUserSharedLine className='text-xl -scale-x-100' />
            <span className='text-sm'>سمت فرستنده</span>
          </div>
        ),

        value: 'sender',
      },
      {
        label: (
          <div className='flex items-center gap-1 pt-1'>
            <RiUserReceivedLine className='text-xl ' />
            <span className='text-sm '>سمت گیرنده</span>
          </div>
        ),
        value: 'receiver',
      },
      // {
      //   label: (
      //     <div className='flex items-center gap-1 pt-1'>
      //       <UserSwitchOutlined className='text-xl ' />
      //       <span className='text-sm '> نقدی‌‌ - پسکرایه</span>
      //     </div>
      //   ),
      //   value: 'cashAndPayInPlace',
      // },
    ];
    return options;
  }, []);
  const setError = (error: string) => handleChange({ paymentTypeError: error });

  console.log('availableMethodIds', availableMethodIds);

  return (
    <OrderMethodItem icon={<DollarOutlined className='text-2xl' />} title='هزینه ارسال'>
      <div className='primary-segmented'>
        <div className='mb-1'>
          <span className='text-sm text-t-secondary-text-color'>پرداخت هزینه ارسال : </span>
        </div>

        <Segmented className='primary-segmented' options={segmentedOptions} onChange={handleSideChange} value={orderMethods.paymentSide} />
      </div>
      <div className=''>
        <div className='py-4 space-y-4'>
          <PaymentTypeReceiverNoCOD
            invalid={!availableMethodIds.includes(20)}
            isSelected={orderMethods.paymentTypeId == 20}
            onChange={() => handleChange({ paymentTypeId: 20 })}
            setError={setError}
            error={orderMethods.paymentTypeError || ''}
          />
          <PaymentTypeSenderNoCOD
            invalid={!availableMethodIds.includes(80)}
            isSelected={orderMethods.paymentTypeId == 80}
            onChange={() => handleChange({ paymentTypeId: 80 })}
            setError={setError}
            error={orderMethods.paymentTypeError || ''}
          />

          {/* <OrderMethodPaymentTypeCashAndPayInPlace
            invalid={!availableMethodIds.includes(100)}
            isSelected={orderMethods.paymentTypeId == 100}
            onChange={() => handleChange({ paymentTypeId: 100 })}
            setError={setError}
            error={orderMethods.paymentTypeError || ''}
            priceList={priceList}
            setCashAmount={setCashAmount}
            cashAmount={cashAmount}
          /> */}
        </div>
      </div>
    </OrderMethodItem>
  );
};

export default OrderMethodPaymentType;
